export default __webpack_public_path__ + "static/logo-print-1960946aed951aeaabe6e54325b85f8b.png";